<script lang="ts" context="module">
  export const preferencesDialog = createDialog({ label: 'Preferences' });
</script>

<script lang="ts">
  import { page } from '$app/stores';
  import { createDialog } from 'svelte-headlessui';
  import Transition from 'svelte-transition';
  import AlertConfig from './preferences/AlertConfig.svelte';
  import CustomiseLayouts from './preferences/CustomiseLayouts.svelte';
  import BettingConfig from './preferences/BettingConfig.svelte';
  import PreferencesTabs, {
    activeTab
  } from './preferences/PreferencesTabs.svelte';
  import SiteConfig from './preferences/SiteConfig.svelte';

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfigName = layoutConfigStore?.activeLayoutConfigName;
</script>

<div class="absolute z-50">
  <Transition show={$preferencesDialog.expanded}>
    <Transition
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        class="fixed inset-0 bg-black bg-opacity-25"
        on:click={preferencesDialog.close}
        on:keypress={preferencesDialog.close}
      />
    </Transition>

    <div class="fixed inset-0 flex h-full w-full items-center overflow-auto">
      <div
        class="flex h-full w-full items-center justify-center p-4 text-center md:h-3/4"
      >
        <Transition
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div
            class="relative flex h-full w-full max-w-screen-lg transform flex-col gap-y-3 overflow-y-auto rounded-2xl bg-white p-4 text-left align-middle shadow-xl transition-all"
            use:preferencesDialog.modal
          >
            <PreferencesTabs />
            {#if $activeTab === 'Customise Layouts'}
              <CustomiseLayouts />
            {:else if $activeTab === 'Site Config'}
              <SiteConfig />
            {:else if $activeTab === 'Alerts'}
              <AlertConfig />
            {:else if $activeTab === 'Betting'}
              <BettingConfig />
            {/if}
          </div>
        </Transition>
      </div>
    </div>
  </Transition>
</div>
